import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const ChevronLeftIcon: FC<IconProps> = ({ width = 10, height = 10, ...rest }) => (
  <Icon type="ChevronLeftIcon" width={width} height={height} alt="ChevronLeftIcon" ignoreRtl {...rest} />
)
